module.exports = __webpack_public_path__ + "static/sport/login.a441161.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport7/login.gif
// module id = 8Vu/
// module chunks = 0